import * as theme from './theme';
export default theme;
//# sourceMappingURL=index.js.map